module.exports = __webpack_public_path__ + "img/FilterIndicator.05a4a619.svg";